import { MapView } from './types';
import { LayoutGrid, Box } from 'lucide-react';

type ViewToggleProps = {
  value: MapView;
  onChange: (view: MapView) => void;
};

export default function ViewToggle({ value, onChange }: ViewToggleProps) {
  return (
    <div className="bg-white/80 backdrop-blur-sm rounded-lg shadow-sm p-1 flex gap-1">
      <button
        onClick={() => onChange('2D')}
        className={`p-2 rounded transition-colors ${
          value === '2D' 
            ? 'bg-[#005E6E] text-white' 
            : 'text-gray-600 hover:text-gray-900'
        }`}
        title="2D View"
      >
        <LayoutGrid className="h-4 w-4" />
      </button>
      <button
        onClick={() => onChange('3D')}
        className={`p-2 rounded transition-colors ${
          value === '3D' 
            ? 'bg-[#005E6E] text-white' 
            : 'text-gray-600 hover:text-gray-900'
        }`}
        title="3D View"
      >
        <Box className="h-4 w-4" />
      </button>
    </div>
  );
} 